import { render } from "./MsgSucess.vue?vue&type=template&id=d24d6704&scoped=true"
import script from "./MsgSucess.vue?vue&type=script&lang=js"
export * from "./MsgSucess.vue?vue&type=script&lang=js"

import "./MsgSucess.vue?vue&type=style&index=0&id=d24d6704&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src130918171/src/app-heineken/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d24d6704"]])

export default __exports__